<template>
  <div class="mv-bottom">
    <div class="mv-bottom__body">
      <img class="catch-copy" src="@/assets/catch-copy.svg" alt="" />
      <picture>
        <source type="image/webp" srcset="@/assets/bottle.webp" />
        <img class="bottle" src="@/assets/bottle.png" alt="" />
      </picture>
    </div>
    <svg
      class="mv-bottom__tri"
      width="1604"
      height="547"
      viewBox="0 0 1604 547"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#product-shadow)">
        <path
          d="M1532 17.0001L662 393L1261 540L1532 17.0001Z"
          opacity="0.1"
          fill="white"
        />
      </g>
      <path d="M1532 17.0001L662 393L1261 540L1532 17.0001Z" fill="white" />

      <g filter="url(#product-shadow)">
        <path
          d="M1357.84 97L611.61 391.476L971.048 458.27L1357.84 97Z"
          opacity="0.1"
          fill="white"
        />
      </g>
      <path
        d="M1357.84 97L611.61 391.476L971.048 458.27L1357.84 97Z"
        fill="white"
      />

      <g filter="url(#product-shadow)">
        <path
          class="fragment"
          d="M1074.4 178L-2.16343 488.124L436.414 538.282L1074.4 178Z"
          opacity="0.1"
          fill="white"
        />
      </g>
      <path
        class="fragment"
        d="M1074.4 178L-2.16343 488.124L436.414 538.282L1074.4 178Z"
        fill="white"
      />

      <filter id="product-shadow">
        <feGaussianBlur in="SourceAlpha" stdDeviation="8"></feGaussianBlur>
        <feOffset dx="8" dy="8" />
      </filter>
    </svg>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.scroll {
  position: absolute;
  left: 0;
  top: -20rem;
  height: 30rem;
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;
  @media screen and (max-width: $breakpoint-mobile) {
    display: none;
  }

  .bar {
    position: relative;
    display: block;
    width: 0.2rem;
    height: 20rem;
    background: var(--main-color);

    @keyframes scrolldown {
      0% {
        transform: translate(0, 0);
        height: 0;
      }
      80% {
        transform: translate(0, 20rem);
        height: 6rem;
      }
      100% {
        transform: translate(0, 20rem);
        height: 6rem;
      }
    }

    &:after {
      position: absolute;
      content: '';
      display: block;
      width: 100%;
      height: 0;
      transform: translate(0, 0);
      background: #fff;
      animation: scrolldown 2s cubic-bezier(0.76, 0, 0.3, 1) backwards infinite;
    }
  }

  .label {
    font-size: 1.2rem;
    letter-spacing: 0.3em;
    color: #fff;
    font-weight: 800;
    margin: 2rem 0 0;
  }
}

.mv-bottom {
  width: 100%;
  display: flex;
  position: absolute;
  top: -17rem;
  z-index: -1;
  @media screen and (max-width: $breakpoint-mobile) {
    top: -11rem;
  }

  &__tri {
    position: absolute;
    top: -27rem;
    right: -30rem;
    z-index: -1;
    @media screen and (max-width: $breakpoint-mobile) {
      width: 270vw;
      // top: -55vw;
      top: -230px;
      right: -34rem;
    }

    .fragment {
      @media screen and (max-width: $breakpoint-mobile) {
        transform: translate(3.8rem, 0px);
      }
    }
  }

  &__body {
    margin: 0 0 0 auto;
    padding: 1.5rem;
    @media screen and (max-width: $breakpoint-mobile) {
      padding: 1.6rem 2rem;
    }
  }
  .catch-copy {
    width: 32rem;
    height: 11rem;
    margin: 0 2rem 0 0;
    @media screen and (max-width: $breakpoint-mobile) {
      width: 15rem;
      height: 6rem;
      margin: 0 1rem -1rem 0;
    }
  }

  .bottle {
    width: 10rem;
    @media screen and (max-width: $breakpoint-mobile) {
      width: 4.2rem;
    }
  }
}
</style>
